module.exports = __webpack_public_path__ + "static/media/gestao-tipo-servico.e49eb1a8.png";